export enum NumerationIncrementType {
    WORK_TYPE = 'WORK_TYPE'
}
